import React from 'react';

const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const copyableText = (value) => {
  if (!value) {
    return '—';
  }
  return <span style={{ wordBreak: 'break-all' }}>{value}</span>;
};

const formatDate = (value) => {
  if (!value) {
    return '—';
  }
  return new Date(value).toLocaleString('it-IT');
};

const fileField = (item) => {
  const file = item?.file;
  if (!file) {
    return '—';
  }
  const url = typeof file === 'string' ? file : file?.url;
  const name = item.file_name || file?.file_name || 'file';

  if (url) {
    return (
      <a href={url} target='_blank' rel='noreferrer'>
        {name}
      </a>
    );
  }
  return display(name);
};

const qrImageField = (qrImage) => {
  const url = qrImage?.url;
  if (!url) {
    return '—';
  }
  return (
    <a href={url} target='_blank' rel='noreferrer'>
      <img
        src={url}
        alt='QR Code'
        style={{ maxWidth: 200, maxHeight: 200, objectFit: 'contain' }}
      />
    </a>
  );
};

const destinationFields = (t, item) => {
  if (item.qr_link) {
    return [
      {
        text: t('Tipo di contenuto'),
        value: t('Link esterno'),
      },
      { text: t('Link'), value: copyableText(item.qr_link) },
    ];
  }
  if (item.file) {
    return [
      {
        text: t('Tipo di contenuto'),
        value: t('File (PDF/JPG/DOCX)'),
      },
      { text: t('File (PDF, JPG, DOCX)'), value: fileField(item) },
    ];
  }
  return [
    { text: t('Tipo di contenuto'), value: t('Non definito') },
  ];
};

export const getWebQrViewSections = (t, item) => {
  if (!item?.id) {
    return [];
  }

  return [
    {
      title: t('Informazioni Generali'),
      fields: [
        { text: t('ID'), value: display(item.id) },
        { text: t('Slug'), value: display(item.slug) },
        {
          text: t('Outlet Village'),
          value: display(item.shopping_center?.title),
        },
        { text: t('Link generato'), value: copyableText(item.link) },
        {
          text: t('Contatore aperture'),
          value: display(item.count_open ?? 0),
        },
        { text: t('Data creazione'), value: formatDate(item.created_at) },
        { text: t('QR Code'), value: qrImageField(item.qr_image) },
      ],
    },
    {
      title: t('Destinazione'),
      fields: destinationFields(t, item),
    },
  ];
};
